import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import clsx from 'clsx'

function StatsCard({ name, value, icon: Icon, change, changeType }) {
  const getChangeIcon = () => {
    switch (changeType) {
      case 'positive':
        return TrendingUp
      case 'negative':
        return TrendingDown
      default:
        return Minus
    }
  }

  const ChangeIcon = getChangeIcon()

  return (
    <div className="card">
      <div className="card-body">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <Icon className="h-8 w-8 text-primary-600" />
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-primary-500 truncate">
                {name}
              </dt>
              <dd className="flex items-baseline">
                <div className="text-2xl font-semibold text-primary-900">
                  {typeof value === 'number' ? value.toLocaleString() : value}
                </div>
                {change && (
                  <div className={clsx(
                    'ml-2 flex items-baseline text-sm font-semibold',
                    changeType === 'positive' && 'text-green-600',
                    changeType === 'negative' && 'text-red-600',
                    changeType === 'neutral' && 'text-primary-500'
                  )}>
                    <ChangeIcon className="h-4 w-4 flex-shrink-0 self-center" />
                    <span className="ml-1">{change}</span>
                  </div>
                )}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatsCard